module.exports = __webpack_public_path__ + "img/a4cbe67.svg";